// extracted by mini-css-extract-plugin
export default {"conversationHeader":"BoxContainer_conversationHeader__zzSla","pageTitle":"BoxContainer_pageTitle__M2ZYG"};